if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', class extends HTMLElement {
  constructor() {
    super();
    this.mobile = window.matchMedia('(max-width: 749px)');
    this.onEscape = event => { if (event.key === 'Escape' && this.classList.contains('active')) { event.preventDefault(); this.close(); } };
    this.onViewportChange = () => { this.close({ immediate: true }); this.updateCartLink(); };
    this.mobile.addEventListener('change', this.onViewportChange);
    this.addEventListener('keyup', event => { if (event.code === 'Escape') this.close(); });
    this.addEventListener('click', event => { if (event.target.closest('[data-drawer-close],[data-notice-close],#CartDrawer-Overlay')) this.close(); });
    this.addEventListener('pointerdown', event => { if (event.target.closest('.shc-mobile-notice')) this.startNoticeTimer(); });
    this.addEventListener('keydown', event => { if (event.key !== 'Escape' && event.target.closest('.shc-mobile-notice')) this.startNoticeTimer(); });
    const link = document.getElementById('cart-icon-bubble');
    if (link) {
      link.addEventListener('click', event => { if (!this.mobile.matches) { event.preventDefault(); this.open(link); } });
      link.addEventListener('keydown', event => { if (event.code === 'Space' && !this.mobile.matches) { event.preventDefault(); this.open(link); } });
    }
    this.updateCartLink();
  }
  updateCartLink() {
    const link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    if (this.mobile.matches) { link.removeAttribute('role'); link.removeAttribute('aria-haspopup'); }
    else { link.setAttribute('role', 'button'); link.setAttribute('aria-haspopup', 'dialog'); }
  }
  startNoticeTimer() {
    clearTimeout(this.noticeTimer);
    if (this.classList.contains('is-notice') && this.classList.contains('active') && !this.classList.contains('is-closing')) this.noticeTimer = setTimeout(() => this.close(), 5000);
  }
  setAddedHeading(added) {
    this.querySelector('[data-drawer-added]').hidden = !added;
    this.querySelector('[data-drawer-title]').hidden = added;
  }
  focusPanel(inner, notice) {
    requestAnimationFrame(() => {
      const finish = () => {
        if (this.classList.contains('active') && !this.classList.contains('is-closing') && inner.isConnected && !inner.hidden) {
          trapFocus(inner, inner.querySelector(notice ? '[data-notice-view]' : '[data-drawer-close]'));
          this.startNoticeTimer();
        }
      };
      const animations = inner.getAnimations().filter(animation => animation.animationName?.startsWith('shc-'));
      if (animations.length) Promise.allSettled(animations.map(animation => animation.finished)).then(finish);
      else finish();
    });
  }
  open(trigger, { notification = false, added = false } = {}) {
    if (this.mobile.matches && !notification) { window.location.assign(window.routes?.cart_url || '/cart'); return; }
    if (this.classList.contains('active') && !notification && !this.classList.contains('is-closing')) return;
    this.closeSequence = (this.closeSequence || 0) + 1;
    this.classList.remove('is-closing');
    if (trigger) this.setActiveElement(trigger);
    const notice = this.mobile.matches && notification;
    this.setAddedHeading(added);
    this.classList.toggle('is-notice', notice);
    this.querySelector('.drawer__inner').hidden = notice;
    this.querySelector('.shc-mobile-notice').hidden = !notice;
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this.onEscape);
    const inner = this.querySelector(notice ? '.shc-mobile-notice' : '.drawer__inner');
    this.focusPanel(inner, notice);
    const cart = this.querySelector('sh-cart');
    Promise.resolve(cart?.activate()).then(() => { if (this.classList.contains('active') && !this.classList.contains('is-notice')) cart?.dispatchViewEvent?.(); });
  }
  close({ immediate = false } = {}) {
    clearTimeout(this.noticeTimer);
    if (!this.classList.contains('active')) return;
    if (this.classList.contains('is-closing') && !immediate) return;
    const sequence = this.closeSequence = (this.closeSequence || 0) + 1;
    document.removeEventListener('keydown', this.onEscape);
    const finish = () => {
      if (this.closeSequence !== sequence) return;
      this.classList.remove('active', 'is-closing');
      removeTrapFocus(this.activeElement?.isConnected ? this.activeElement : document.getElementById('cart-icon-bubble'));
      document.body.classList.remove('overflow-hidden');
    };
    if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return; }
    this.classList.add('is-closing');
    const inner = this.querySelector(this.classList.contains('is-notice') ? '.shc-mobile-notice' : '.drawer__inner');
    requestAnimationFrame(() => {
      if (this.closeSequence !== sequence) return;
      const animations = inner.getAnimations().filter(animation => animation.animationName?.endsWith('-exit'));
      if (animations.length) Promise.allSettled(animations.map(animation => animation.finished)).then(finish);
      else finish();
    });
  }
  renderContents(state) {
    this.closeSequence = (this.closeSequence || 0) + 1;
    this.classList.remove('is-closing');
    const html = state.sections?.['cart-drawer'];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('#CartDrawer');
      if (next) this.querySelector('#CartDrawer').innerHTML = next.innerHTML;
    }
    const bubble = state.sections?.['cart-icon-bubble'];
    if (bubble) {
      const content = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section');
      if (content && document.getElementById('cart-icon-bubble')) document.getElementById('cart-icon-bubble').innerHTML = content.innerHTML;
    }
    this.classList.toggle('is-empty', !this.querySelector('[data-cart-form]'));
    this.setAddedHeading(true);
    if (this.mobile.matches) {
      this.noticeItems = Array.isArray(state.items) ? state.items : [state];
      this.updateNoticeContent();
      this.open(null, { notification: true });
    } else if (this.classList.contains('active')) this.focusPanel(this.querySelector('.drawer__inner'), false);
    else this.open(null, { added: true });
  }
  updateNoticeContent(doc = this) {
    if (doc !== this) {
      const next = doc.querySelector('[data-notice-summary]');
      const current = this.querySelector('[data-notice-summary]');
      if (next && current) current.replaceWith(next.cloneNode(true));
    }
    if (!this.noticeItems?.length) return;
    const templates = [...doc.querySelectorAll('[data-notice-template]')];
    const added = this.querySelector('[data-notice-items]');
    const fragment = document.createDocumentFragment();
    for (const item of this.noticeItems) {
      const template = templates.find(t => t.dataset.key === item.key) || templates.find(t => t.dataset.variant === String(item.variant_id || item.id));
      if (template) fragment.append(template.content.cloneNode(true));
    }
    added.replaceChildren(fragment);
  }
  getSectionsToRender() { return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }]; }
  setActiveElement(element) { this.activeElement = element; }
});
